import React from "react";
import PropTypes from "prop-types";
import { BrlFormatCurrency, FormatPoints } from "../../../../lib";
import {
  CartFinancialSummaryWrap,
  CartFinancialSummaryRows,
  CartFinancialSummaryRow,
  CartFinancialSummaryDivider,
  CartFinancialSummaryTotalRow,
} from "../../styles";

function formatValue(displayMode, money, points) {
  if (displayMode === "points") return `${FormatPoints(points)} pts`;
  if (displayMode === "both") {
    return `${BrlFormatCurrency(money)} ou ${FormatPoints(points)} pts`;
  }
  return BrlFormatCurrency(money);
}

function getCartFinancialTotals(cart) {
  const summary = cart?.summary || {};
  const subtotalMoney = parseFloat(summary.subtotal || 0);
  const shippingMoney = parseFloat(summary.shipping || 0);
  const totalMoney = parseFloat(summary.total || 0);

  const productPoints = (cart?.items || []).reduce((acc, item) => {
    const qty = parseInt(item.quantity || 1, 10);
    const points = parseFloat(
      item.price?.points?.offer || item.price?.points?.price || 0,
    );
    return acc + Math.round(points) * qty;
  }, 0);

  const shippingPoints = Object.values(cart?.shipping_by_brand || {}).reduce(
    (acc, brand) => acc + Math.round(parseFloat(brand?.shipping_point || 0)),
    0,
  );

  return {
    subtotalMoney,
    shippingMoney,
    totalMoney,
    productPoints,
    shippingPoints,
    totalPoints: productPoints + shippingPoints,
  };
}

export default function CartFinancialSummary({ cart, displayMode = "money" }) {
  const totals = getCartFinancialTotals(cart);

  return (
    <CartFinancialSummaryWrap>
      <CartFinancialSummaryRows>
        <CartFinancialSummaryRow>
          <span className="label">Frete do pedido:</span>
          <span className="value">
            {formatValue(displayMode, totals.shippingMoney, totals.shippingPoints)}
          </span>
        </CartFinancialSummaryRow>
        <CartFinancialSummaryRow>
          <span className="label">Subtotal do pedido:</span>
          <span className="value">
            {formatValue(displayMode, totals.subtotalMoney, totals.productPoints)}
          </span>
        </CartFinancialSummaryRow>
      </CartFinancialSummaryRows>

      <CartFinancialSummaryDivider />

      <CartFinancialSummaryTotalRow>
        <span className="total-label">Total do Pedido</span>
        <span className="total-value">
          {formatValue(displayMode, totals.totalMoney, totals.totalPoints)}
        </span>
      </CartFinancialSummaryTotalRow>
    </CartFinancialSummaryWrap>
  );
}

CartFinancialSummary.propTypes = {
  cart: PropTypes.shape({
    items: PropTypes.array,
    summary: PropTypes.object,
    shipping_by_brand: PropTypes.object,
  }),
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
};
